import { render, staticRenderFns } from "./weChat.vue?vue&type=template&id=0a46b05b&scoped=true&"
import script from "./weChat.vue?vue&type=script&lang=js&"
export * from "./weChat.vue?vue&type=script&lang=js&"
import style0 from "./weChat.vue?vue&type=style&index=0&id=0a46b05b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a46b05b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a46b05b')) {
      api.createRecord('0a46b05b', component.options)
    } else {
      api.reload('0a46b05b', component.options)
    }
    module.hot.accept("./weChat.vue?vue&type=template&id=0a46b05b&scoped=true&", function () {
      api.rerender('0a46b05b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/decoration/weChat.vue"
export default component.exports